// risksChart.ts

type RiskItem = {
  level?: number;
  label: string;
  min: number;
  max: number;
  total: number;
};

export const buildRisks = (data?: any): RiskItem[] => [
  {
    level: data?.request?.heart_level,
    label: 'Maladies cardiovasculaires',
    min: 3,
    max: 5,
    total: 8,
  },
  {
    level: data?.request?.dread_level,
    label: 'Angoisse',
    min: 3,
    max: 7,
    total: 12,
  },
  {
    level: data?.request?.digestion_level,
    label: 'Problèmes gastro-intestinaux',
    min: 6,
    max: 12,
    total: 20,
  },
  {
    level: data?.request?.anxiety_level,
    label: 'Anxiété',
    min: 6,
    max: 12,
    total: 20,
  },
  {
    level: data?.request?.insomnia_level,
    label: 'Insomnies',
    min: 3,
    max: 7,
    total: 12,
  },
];
